import React from 'react';

import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Badge,
  HStack,
  Text,
} from '@chakra-ui/react';

import { VERIFIED_EBAY_SELLER } from '../constants/defaultItemSpecsConfig';

const VerifiedSellerContent = () => (
  <Alert
    status="info"
    variant="left-accent"
    borderRadius="lg"
    alignItems="flex-start"
    py={4}
  >
    <AlertIcon mt={1} />
    <Box flex={1}>
      <AlertTitle fontSize="md" mb={1}>
        Verified eBay reference seller
      </AlertTitle>
      <AlertDescription fontSize="sm">
        The optimizer uses verified listing data from{' '}
        <Badge colorScheme="blue" fontSize="sm" mx={1}>
          {VERIFIED_EBAY_SELLER.username}
        </Badge>
        ({VERIFIED_EBAY_SELLER.label}) as the source of truth when fetching and applying updates.
        {VERIFIED_EBAY_SELLER.description}
      </AlertDescription>
      <HStack mt={2} spacing={2} flexWrap="wrap">
        <Badge colorScheme="green" variant="subtle">
          Verified source
        </Badge>
        <Text fontSize="xs" color="gray.600">
          Supplier SKU → Partslink mapping is required before each run.
        </Text>
      </HStack>
    </Box>
  </Alert>
);

export default VerifiedSellerContent;
